import React from "react";

const PlaceHolderImg = ({
  color,
  style = { width: "109", height: "109" }
}: {
  color: string;
  style?: { width: string; height: string };
}) => {
  return (
    <svg
      width={style.width}
      height={style.height}
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_32_33"
        maskUnits="userSpaceOnUse"
        x="71"
        y="71"
        width="38"
        height="38"
      >
        <path d="M71.5103 71.0609H109V108.5H71.5103V71.0609Z" fill="white" />
      </mask>
      <g mask="url(#mask0_32_33)">
        <path
          d="M97.0681 90.3229C96.7496 90.678 96.3072 90.8584 95.8647 90.8584C95.4758 90.8584 95.0897 90.7203 94.7769 90.4413L92.1279 88.0543V95.6013C92.1279 96.4975 91.4036 97.2245 90.5074 97.2245C89.6113 97.2245 88.8842 96.4975 88.8842 95.6013V88.0543L86.2351 90.4413C85.5672 91.0415 84.5414 90.988 83.944 90.3229C83.3437 89.655 83.3973 88.632 84.0623 88.0318L89.4196 83.2043C90.0368 82.6463 90.9753 82.6463 91.5924 83.2043L96.9497 88.0318C97.6148 88.632 97.6683 89.655 97.0681 90.3229ZM90.5074 71.5118C80.3086 71.5118 72.012 79.8084 72.012 90.0045C72.012 100.203 80.3086 108.5 90.5074 108.5C100.703 108.5 109 100.203 109 90.0045C109 79.8084 100.703 71.5118 90.5074 71.5118Z"
          fill="#101318"
        />
      </g>
      <mask
        id="mask1_32_33"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="109"
        height="109"
      >
        <path
          d="M0.859375 0.359375H109V108.5H0.859375V0.359375Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_32_33)">
        <path
          d="M54.9311 0.359375C40.4881 0.359375 26.9103 5.98439 16.6973 16.1973C6.48439 26.4075 0.859375 39.9881 0.859375 54.4283C0.859375 68.8713 6.48439 82.4519 16.6973 92.662C26.9103 102.875 40.4881 108.5 54.9311 108.5C61.7566 108.5 68.3539 107.26 74.6017 104.808C70.9861 100.925 68.7682 95.7197 68.7682 90.0045C68.7682 85.7801 69.98 81.8319 72.0739 78.4924C69.05 76.9734 66.5137 75.6658 65.2483 74.7471C64.1126 73.9242 64.0281 73.2281 63.9999 72.9998C63.7801 71.1681 66.105 68.4316 68.1538 66.0165C69.2642 64.7117 70.4112 63.359 71.2538 62.0598C73.9254 57.9256 76.7041 49.7643 74.7765 34.3575C72.9729 19.9539 61.007 16.1466 54.9311 16.1466C48.8552 16.1466 36.8893 19.9539 35.0857 34.3575C33.1581 49.7643 35.9368 57.9256 38.6084 62.0598C39.4482 63.359 40.5952 64.7117 41.7056 66.0165C43.7572 68.4316 46.0793 71.1681 45.8595 72.9998C45.8341 73.2281 45.7496 73.9242 44.6139 74.7471C43.1682 75.7954 40.0682 77.3511 36.4779 79.149C31.9942 81.3979 26.4143 84.1907 21.9673 87.0934C20.7104 87.8289 19.5183 88.7279 18.4108 89.7734C9.18135 80.2453 4.10588 67.7271 4.10588 54.4283C4.10588 40.8533 9.39271 28.0899 18.9913 18.4885C28.5899 8.8899 41.3561 3.60306 54.9311 3.60306C68.5061 3.60306 81.2695 8.8899 90.8709 18.4885C100.469 28.0899 105.756 40.8533 105.756 54.4283C105.756 60.5042 104.708 66.3857 102.642 71.9769C103.589 72.6166 104.48 73.3268 105.311 74.1017C107.763 67.8539 109 61.2538 109 54.4283C109 39.9881 103.378 26.4075 93.1649 16.1973C82.9519 5.98439 69.3741 0.359375 54.9311 0.359375Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default PlaceHolderImg;
